import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { InputPlayerStatsModelBase } from './InputPlayerStatsModel.base'

/* The TypeScript type of an instance of InputPlayerStatsModel */
export interface InputPlayerStatsModelType extends RecursiveRemoveUndefined<Instance<typeof InputPlayerStatsModel>> {}

/* A graphql query fragment builders for InputPlayerStatsModel */
export {
  selectFromInputPlayerStats,
  inputPlayerStatsModelPrimitives,
  InputPlayerStatsModelSelector
} from './InputPlayerStatsModel.base'

/**
 * InputPlayerStatsModel
 */
export const InputPlayerStatsModel = InputPlayerStatsModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
